export const ADD_TO_BOARD_LABEL = 'Add to board';
export const UPDATE_NODE_ON_BOARD_LABEL = 'Update node on board';

export function canReuseSynthesiseOutputNode({
	existingTask,
	nextTask,
}: {
	existingTask?: string | null;
	nextTask: string;
}): boolean {
	return Boolean(existingTask) && existingTask === nextTask;
}

export function synthesiseBoardActionLabel(hasExistingNodeForTask: boolean): string {
	if (hasExistingNodeForTask) return UPDATE_NODE_ON_BOARD_LABEL;
	return ADD_TO_BOARD_LABEL;
}
